import Train from '../services/train.js';
import StringUtils from '../services/StringUtils.js'
import User from '../services/User.js'

let Element = {}

Element.url = (type, element) => {

  if (!element)
    return '';

  if (type === 'artist') 
    return `/artists/${encodeURIComponent(element.artist)}`;
  else if (type === 'track')
    return `/artists/${encodeURIComponent(element.artist)}/tracks/${encodeURIComponent(element.track)}`;
  else if (type === 'album')
    return `/artists/${encodeURIComponent(element.artist)}/albums/${encodeURIComponent(element.album)}`;
  else if (type === 'tag')
    return `/tags/${encodeURIComponent(element.tag)}`;
  else if (type === 'user')
    return `/users/${encodeURIComponent(element.user)}`;
  else if (type === 'lastfmUser' || type === 'lastfm_user')
    return `/lastfm-users/${encodeURIComponent(element[type])}`
  else if (type === 'popular')
    return `/populars/${encodeURIComponent(element.popular)}`
  else
    return '';
};

Element.mapUrl = (type, element) => {

  if (!element)
    return '';

  if (type === 'artist') 
    return `/maps/artist/${encodeURIComponent(element[type])}/similar_artists`
  else if (type === 'user')
    return `/maps/user/${encodeURIComponent(element[type])}/artists`;
  else if (type === 'tag')
    return `/maps/tag/${encodeURIComponent(element[type])}/top_artists`;
  else if (type === 'lastfmUser' || type === 'lastfm_user')
    return `/maps/lastfm_user/${encodeURIComponent(element[type])}/top_artists`;
  else
    return '';
};

Element.riverUrl = (type, element) => {

  if (!element)
    return '';
  
  if (type === 'user')
    return `/rivers/user/${encodeURIComponent(element[type])}/top_artists`;
  else if (type === 'lastfmUser' || type === 'lastfm_user')
    return `/rivers/lastfm_user/${encodeURIComponent(element[type])}/top_artists`
  else
    return '';
};

Element.treemapUrl = (type, element) => {

  if (!element)
    return '';

  if (type === 'user')
    return `/treemaps/user/${encodeURIComponent(element[type])}/artists`;
  else
    return '';
};

Element.userLibraryUrl = (type, userData) => {

  if (!userData)
    return '';

  if (type === 'artist' && userData.playcount && userData.playcount > 0) {
    let encodedArtist = encodeURIComponent(userData[type]);
    return `/users/${User.getId()}/scrobbles?match=${encodedArtist}`;
  } else if (type === 'track' && userData.playcount && userData.playcount > 0) {
    let encodedArtistAndTrack = encodeURIComponent(userData.artist + ' - ' + userData.track);
    return `/users/${User.getId()}/scrobbles?match=${encodedArtistAndTrack}`;
  } else {
    return '';
  }
};

Element.lastfmUserUrl = (type, element) => {

  if (!element)
    return '';

  if (type === 'lastfmUser' || type === 'lastfm_user')
    return `//www.last.fm/user/${encodeURIComponent(element[type])}`;
  else
    return '';
};


Element.nameById = (type, id, cb) => {
  if (type === 'user')
  {
    Train.fetchUser({user: id})
    .then((user) => cb(user.username));
  } else if (type === 'popular') {
    cb(StringUtils.titleize(id + ' top artists'));
  } else {
    cb(decodeURIComponent(id));
  }
}

Element.name = (type, element) => {
  
  if (!element)
    return '';
  
  if (type !== 'user')
    return element[type];
  else
    return element.name;

};

module.exports = Element;


// WEBPACK FOOTER //
// ./src/js/services/Element.js